/* eslint-env browser */
import * as React from 'react'

import { successToast } from '../../scripts/toast'

const classNames = require('classnames')
const PropTypes = require('prop-types')
const axios = require('axios')
const DomHelper = require('../../../../client/clientjs/dom-helper.js')

const ALL_SHARE = [
  {
    key: 'facebook',
    title: 'Facebook',
    icon: 'fab fa-facebook',
    color: '#3b5998',
    getLink: ({ url }) => `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  },
  {
    key: 'twitter',
    title: 'Twitter',
    icon: 'fab fa-twitter',
    color: '#1da1f2',
    getLink: ({ url, title }) => `https://twitter.com/intent/tweet?text=${title}&url=${url}&via=Fish_Friender`,
  },
  {
    key: 'email',
    title: 'Email',
    icon: 'far fa-at',
    getLink: ({ url, title }) => `mailto:?subject=${title}&body=${url}`,
  },
  {
    key: 'copy',
    title: 'Copy',
    icon: 'far fa-copy',
    color: '#1F2259',
    onClick: ({ url, title }) => {
      DomHelper.copyToClipBoard(url)
      successToast({ message: 'Copied to clipboard!' })
    },
  },
]

class ShareModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      metadatasByUrl: {},
    }
    this.expandCurrentDescription = this.expandCurrentDescription.bind(this)
    this.fetchMetadata = this.fetchMetadata.bind(this)
  }

  componentDidMount() {
    this.fetchMetadata(this.props.shareableLink)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.shareableLink && this.props.shareableLink !== nextProps.shareableLink) {
      this.fetchMetadata(nextProps.shareableLink)
    }
  }

  expandCurrentDescription() {
    const { shareableLink } = this.props
    if (!shareableLink) {
      return
    }
    this.setState(prevState => ({
      metadatasByUrl: {
        ...prevState.metadatasByUrl,
        [shareableLink]: {
          ...prevState.metadatasByUrl[shareableLink],
          expanded: true,
        },
      },
    }))
  }

  fetchMetadata(url) {
    const { host } = this.props
    const { metadatasByUrl } = this.state
    if (
      metadatasByUrl[url] &&
      (metadatasByUrl[url].downloading || metadatasByUrl[url].downloaded || metadatasByUrl[url].error)
    ) {
      return
    }
    this.setState(
      {
        metadatasByUrl: {
          ...metadatasByUrl,
          [url]: { downloading: true },
        },
      },
      () => {
        axios(url)
          .then(async response => {
            const html = response.data || ''
            const titles = html.match(/<meta name="title" content="(.*)"[ ]{0,1}\/>/)
            const descriptions = html.match(/<meta name="description" content="(.*)"[ ]{0,1}\/>/)
            const images = html.match(/<meta name="twitter:image" content="(.*)"[ ]{0,1}\/>/)
            const branchDeepLink = html.match(/<meta name="branch:deeplink:\$deeplink_path" content="(.*)"[ ]{0,1}\/>/)

            const title = titles ? titles[1] : null
            const description = descriptions ? descriptions[1] : null
            const image = images ? images[1] : null

            let branchLinkToUseInsteadOfLink = null

            if (window.branch && branchDeepLink && branchDeepLink.length > 0) {
              const linkData = {
                data: {
                  $fallback_url: host + url,
                  $deeplink_path: branchDeepLink[1],
                  $og_title: title,
                  $og_description: description,
                  $og_image_url: image,
                },
              }
              branchLinkToUseInsteadOfLink = await new Promise(resolve => {
                window.branch.link(linkData, function(err, link) {
                  resolve(link)
                })
              })
            }

            this.setState({
              metadatasByUrl: {
                ...metadatasByUrl,
                [url]: {
                  downloaded: true,
                  downloading: false,
                  error: false,
                  metadata: { title, description, image, branchLinkToUseInsteadOfLink },
                },
              },
            })
          })
          .catch(err => {
            this.setState({
              metadatasByUrl: {
                ...metadatasByUrl,
                [url]: {
                  downloaded: true,
                  downloading: false,
                  error: true,
                },
              },
            })
          })
      }
    )
  }

  render() {
    const { isActive, onHide, shareableLink, host } = this.props
    const { metadatasByUrl } = this.state

    const metadata = metadatasByUrl[shareableLink] || {}
    let shareableTitle

    const fullLink = `${host}${shareableLink}`

    let metadataComponent
    if (!metadata || metadata.error) {
      metadataComponent = undefined
    } else if (metadata.downloading) {
      metadataComponent = <div className="loader is-size-1 is-primary is-self-centered" />
    } else if (metadata.downloaded) {
      const { title, description, image, branchLinkToUseInsteadOfLink } = metadata.metadata
      const { expanded } = metadata

      shareableTitle = (title || '').replace(' | FishFriender', '').trim()

      metadataComponent = (
        <div className="box">
          <div className="has-margin-bottom-small">
            <article className="media">
              {image && (
                <div className="media-left">
                  <figure className="image is-128x128-tablet is-64x64-mobile">
                    <img src={image} alt="" />
                  </figure>
                </div>
              )}
              <div className="media-content">
                <div className="content" style={{ position: 'relative' }} onClick={this.expandCurrentDescription}>
                  <p className={classNames('has-bottom-fade', { 'is-expanded': expanded })}>
                    {expanded}
                    {shareableTitle && <strong dangerouslySetInnerHTML={{ __html: shareableTitle }} />}
                    {description && <br />}
                    {description && <small dangerouslySetInnerHTML={{ __html: description }} />}
                  </p>
                  {!expanded && <div className="bottom-fade" />}
                </div>
              </div>
            </article>
          </div>
          <div className="has-text-centered has-text-grey is-size-8 has-margin-bottom-small">
            {branchLinkToUseInsteadOfLink || fullLink}
          </div>
          <div className="buttons is-centered">
            {ALL_SHARE.map(share => (
              <a
                key={share.key}
                href={
                  share.getLink
                    ? share.getLink({ url: branchLinkToUseInsteadOfLink || fullLink, title: shareableTitle || '' })
                    : null
                }
                onClick={
                  share.onClick
                    ? () =>
                        share.onClick({ url: branchLinkToUseInsteadOfLink || fullLink, title: shareableTitle || '' })
                    : null
                }
                target="_blank"
                rel="noopener noreferrer"
                className="button is-medium is-primary"
                type="button"
                style={{ backgroundColor: share.color }}
              >
                <span className="icon is-medium">
                  <i className={share.icon} />
                </span>
                <span>{share.title}</span>
              </a>
            ))}
          </div>
        </div>
      )
    }

    return (
      <div className={classNames('modal', { 'is-active': isActive })}>
        <div className="modal-background" onClick={onHide} />
        <div className="modal-content">{metadataComponent}</div>
        <button type="button" className="modal-close is-large" aria-label="close" onClick={onHide} />
      </div>
    )
  }
}

ShareModal.propTypes = {
  isActive: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  shareableLink: PropTypes.string,
  host: PropTypes.string.isRequired,
}

ShareModal.defaultProps = {
  shareableLink: null,
}

module.exports = ShareModal
